import { ASPExperiment } from './ASPExperiment'

export type FirstImpressionForcedRankingExperiment = {
  experimentKey: string
  variationsValueMap: Record<string, string>
}

export enum FIRST_IMPRESSION_VARIATIONS {
  FirstImpressionTestControl = 'FirstImpressionTestControl',
  FirstImpressionTestEnabled = 'FirstImpressionTestEnabled',
}

export const FirstImpressionSetName = {
  experimentKey: 'explicit_set_name',
  variationsValueMap: {
    [FIRST_IMPRESSION_VARIATIONS.FirstImpressionTestEnabled]: 'FirstImpressionTest',
  },
} as ASPExperiment

export const FirstImpressionSetExploration = {
  experimentKey: 'explicit_set_exploration',
  variationsValueMap: {
    [FIRST_IMPRESSION_VARIATIONS.FirstImpressionTestEnabled]: '0.5',
  },
} as ASPExperiment

export const FIRST_IMPRESSION_EXPERIMENT_NAME = 'gallery_first_impression_forceranking'
